<template>
  <b-card>
    <b-row>
      <b-col>
        <divisoria-descricao
          :titulo="'Nova implantação'"
          :descricao="'Ao cadastrar uma nova implantação, um banco de dados será gerado'"
        />
        <!-- <b-row>
          <b-col cols="4">
            <cnpj-input
              v-model="novoCliente.inscricao"
              :incricao-exist="incricaoExist"
              @dados-navegacao="alimentarDadosDoCNPJ"
              @input="validaLogin"
            />
          </b-col>
          <b-col cols="8">
            <b-form-group
              label="Razão Social"
            >
              <b-form-input
                v-model="novoCliente.razaoSocial"
              />
            </b-form-group>
          </b-col>
        </b-row> -->
        <stepper
          :steps="steps"
        >
          <template #step-0>
            <StepperStep>
              <b-col cols="12">
                <b-row>
                  <b-col cols="6">
                    <b-form-group
                      label="Nome da Base"
                    >
                      <b-form-input
                        v-model="novoCliente.tenantName"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group
                      label="Template da Base"
                    >
                      <select-base
                        v-model="selectedTenantTemplate"
                        :disabled="novoCliente.initializationStrategy !== 1"
                        :carregar="carregar"
                        label-select="name"
                        :require="true"
                        placeholder="Selecione o nome da base"
                        @input="loadTemplateInformation"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </StepperStep>
          </template>
          <template #step-1>
            <StepperStep>
              <tabela-repeticao
                v-model="usuariosParaRegistrar"
                :colunas="colunasTabelaUsuarios"
                :bordered="true"
              >
                <template #visualizacao="{ slotScope }">
                  <b-form-input
                    v-if="slotScope.key === 'nome'"
                    v-model="slotScope.item.nome"
                  />

                  <b-form-input
                    v-else-if="slotScope.key === 'email'"
                    v-model="slotScope.item.email"
                  />

                  <div
                    v-else-if="slotScope.key === 'password'"
                    class="d-flex"
                  >
                    <b-form-input
                      v-model="slotScope.item.password"
                      :type="slotScope.item.showPassword ? 'text' : 'password'"
                    />
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      class="ml-2"
                      @click="togglePasswordVisibility(slotScope.item)"
                    >
                      {{ slotScope.item.showPassword ? 'Ocultar' : 'Ver' }}
                    </b-button>
                  </div>

                  <b-select
                    v-else-if="slotScope.key === 'grupoUsuario'"
                    v-model="slotScope.item.grupoUsuario"
                    @focus="listarGrupoUsuariosBaseTemplate()"
                  >
                    <option
                      v-for="(grupo, index) in grupoUsuarios"
                      :key="grupo.id || index"
                      :value="grupo.id"
                    >
                      {{ grupo.nome }}
                    </option>
                  </b-select>

                  <b-select
                    v-else-if="slotScope.key === 'funcoes'"
                    v-model="slotScope.item.funcoes"
                    @focus="listarGrupoUsuariosBaseTemplate()"
                  >
                    <option
                      v-for="(funcao, index) in funcoes"
                      :key="funcao.id || index"
                      :value="funcao.id"
                    >
                      {{ funcao.nome }}
                    </option>
                  </b-select>

                </template>
                <template #edicao="{ slotScope }">
                  <b-form-input
                    v-if="slotScope.key === 'nome'"
                    v-model="slotScope.item.nome"
                  />

                  <b-form-input
                    v-else-if="slotScope.key === 'email'"
                    v-model="slotScope.item.email"
                  />

                  <div
                    v-else-if="slotScope.key === 'password'"
                    class="d-flex"
                  >
                    <b-form-input
                      v-model="slotScope.item.password"
                      :type="slotScope.item.showPassword ? 'text' : 'password'"
                    />
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      class="ml-2"
                      @click="togglePasswordVisibility(slotScope.item)"
                    >
                      {{ slotScope.item.showPassword ? 'Ocultar' : 'Ver' }}
                    </b-button>
                  </div>

                  <b-select
                    v-else-if="slotScope.key === 'grupoUsuario'"
                    v-model="slotScope.item.grupoUsuario"
                    @focus="listarGrupoUsuariosBaseTemplate()"
                  >
                    <option
                      v-for="(grupo, index) in grupoUsuarios"
                      :key="grupo.id || index"
                      :value="grupo.id"
                    >
                      {{ grupo.nome }}
                    </option>
                  </b-select>

                  <b-select
                    v-else-if="slotScope.key === 'funcoes'"
                    v-model="slotScope.item.funcoes"
                    @focus="listarGrupoUsuariosBaseTemplate()"
                  >
                    <option
                      v-for="(funcao, index) in funcoes"
                      :key="funcao.id || index"
                      :value="funcao.id"
                    >
                      {{ funcao.nome }}
                    </option>
                  </b-select>
                </template>
              </tabela-repeticao>
            </StepperStep>
          </template>
          <template
            #footer="{ goNext, goPrev, currentStep, isLast }"
            class="step-footer"
          >
            <b-button
              variant="none"
              class="btn-outline-danger"
              @click="cancelar"
            >
              Cancelar
            </b-button>
            <div
              class="step-footer-actions"
            >
              <b-button
                variant="none"
                :disabled="currentStep === 0"
                class="btn-outline-secondary"
                @click="goPrev()"
              >
                Voltar
              </b-button>
              <b-button
                v-if="!isLast && podeAvancar && novoCliente.tenantName != ''"
                variant="primary"
                @click="goNext()"
              >
                Avançar
              </b-button>
              <b-button
                v-if="isLast"
                variant="none"
                class="btn-outline-success"
                @click="salvar()"
              >
                Salvar
              </b-button>
            </div>
          </template>
        </stepper>
        <!-- <b-row>
          <b-col>
            <imagem-input
              v-model="novoCliente.logo"
              label-text="Arraste a logo"
            />
          </b-col>
        </b-row> -->
      </b-col>
    </b-row>
  </b-card>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .steps-footer {
    margin-top: 1rem;
    display: flex;
    justify-content: space-between;
  }

  .step-footer-actions {
    display: flex;
    gap: 1rem;
  }
  .cadastro-multiselect .multiselect__tag {
    background-color: var(--primary) !important;
    color: #fff !important;
    border-radius: 6px;
  }

  .cadastro-multiselect .multiselect__tag-icon:after {
    color: #fff !important;
  }

  .cadastro-multiselect .multiselect__option--highlight {
    background: var(--primary) !important;
    color: #fff !important;
  }

  .cadastro-multiselect .multiselect__option--selected {
    background: rgba(0, 123, 255, 0.1) !important; /* exemplo */
    color: var(--primary) !important;
  }

  .multiselect__tag-icon:hover{
    background-color: #4985ff;
  }

</style>

<script>
import { faUser, faCogs } from '@fortawesome/free-solid-svg-icons'
import api from '@/app-modulo/comuns/implantacoes/shared/services/api'
import Stepper from '@/shared/components/stepper/Stepper.vue'
import StepperStep from '@/shared/components/stepper/shared/components/StepperStep.vue'

export default {
  name: 'CadastroClienteSaas',
  components: {
    Stepper,
    StepperStep,
    SelectBase: () => import('@/shared/components/select-base/SelectBase.vue'),
    TabelaRepeticao: () => import('@/shared/components/tabela-repeticao/TabelaRepeticao.vue'),
    // cnpjInput: () => import('@/app-modulo/comuns/empresa/shared/components/empresa-cnpj-input/EmpresaCnpjInput.vue'),
    // imagemInput: () => import('@/shared/components/upload-imagem/UploadImagem.vue'),
  },
  data() {
    return {
      incricaoExist: false,
      novoCliente: this.novoClienteBase(),
      selectedTenantTemplate: null,
      podeAvancar: false,
      initializationStrategyOptions: [
        { text: 'Usar base template', value: 1 },
      ],
      steps: [
        { icon: faCogs, label: 'Configuração' },
        { icon: faUser, label: 'Usuários' },
      ],
      usuariosParaRegistrar: [
        {
          nome: '',
          email: '',
          password: '',
          showPassword: false,
          grupoUsuario: null,
          funcoes: [],
        },
      ],
      colunasTabelaUsuarios: [
        { key: 'nome', label: 'Nome', thStyle: 'width: 360px' },
        { key: 'email', label: 'E-mail', thStyle: 'width: 240px' },
        { key: 'password', label: 'Senha', thStyle: 'width: 240px' },
        { key: 'grupoUsuario', label: 'Grupo de usuário', thStyle: 'width: 200px' },
        { key: 'funcoes', label: 'Funções', thStyle: 'width: 240px' },
      ],
      grupoUsuarios: [],
      funcoes: [],
    }
  },
  computed: {
    podeSalvar() {
      return this.novoCliente.tenantName.trim() !== ''
      && (this.novoCliente.initializationStrategy === 2
      || (this.novoCliente.initializationStrategy === 1 && this.selectedTenantTemplate))
    },
  },
  watch: {
    // When the template changes, reload groups and functions and clear user selections
    selectedTenantTemplate(newVal, oldVal) {
      if (newVal && (!oldVal || newVal.identifier !== oldVal.identifier)) {
        this.listarGrupoUsuariosBaseTemplate()
        // Clear current selections for consistency with the new template
        this.usuariosParaRegistrar = (this.usuariosParaRegistrar || []).map(u => ({
          ...u,
          grupoUsuario: null,
          funcoes: [],
          password: '',
          showPassword: false,
        }))
      }
    },
  },
  methods: {
    novoClienteBase() {
      return {
        tenantName: '',
        initializationStrategy: 1,
        templateDatabaseName: '',
      }
    },
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000)),
      }
      this.options.push(tag)
      this.value.push(tag)
    },
    loadTemplateInformation(e) {
      this.$isLoading(true)
      this.novoCliente.templateDatabaseName = e.identifier

      setTimeout(() => {
        this.$isLoading(false)
        this.podeAvancar = true
      }, 1000)
    },
    salvar() {
      return new Promise((resolve, reject) => {
        if (!this.podeSalvar) {
          this.$erro('Preencha os campos obrigatórios')
          return
        }

        if (this.novoCliente.initializationStrategy === 1 && this.selectedTenantTemplate) {
          this.novoCliente.templateDatabaseName = this.selectedTenantTemplate.identifier
        }

        // Monta o payload incluindo initialUsers quando houver usuários válidos
        const payload = { ...this.novoCliente }
        const initialUsers = (this.usuariosParaRegistrar || [])
          .map(u => {
            const nome = (u.nome || '').toString().trim()
            const email = (u.email || '').toString().trim()
            if (!nome || !email) return null

            // Buscar o objeto de grupo completo (a rota já traz o objeto)
            const grupoObj = this.grupoUsuarios && this.grupoUsuarios.find(g => g.id === u.grupoUsuario)

            // Função: pode ser um id único ou um array; escolher o primeiro id quando for array
            let funcaoId = null
            if (Array.isArray(u.funcoes) && u.funcoes.length) {
              const [first] = u.funcoes
              funcaoId = first
            } else if (u.funcoes) {
              funcaoId = u.funcoes
            }
            const funcaoObj = this.funcoes && this.funcoes.find(f => f.id === funcaoId)

            return {
              Name: nome,
              Email: email,
              Password: (u.password && u.password.toString()) || this.generateRandomPassword(),
              Grupo: grupoObj || null,
              Funcao: funcaoObj || null,
            }
          })
          .filter(Boolean)

        if (initialUsers.length) payload.initialUsers = initialUsers

        this.$isLoading(true)
        api.provisionarTenant(payload)
          .then(() => {
            resolve('Implantação criada com sucesso')
            this.$router.push({ name: 'implantacoes' })
            // Limpar somente após sucesso
            this.clearData()
          })
          .catch(err => {
            this.$isLoading(false)
            reject(err)
          })
          .finally(() => {
            this.$isLoading(false)
          })
      })
    },
    alimentarDadosDoCNPJ(value) {
      const empresaDados = value
      if (empresaDados) {
        this.novoCliente.razaoSocial = empresaDados.razaoSocial
      }
    },
    carregar() {
      return api.listarTemplates()
    },
    clearData() {
      this.novoCliente = this.novoClienteBase()
      this.selectedTenantTemplate = null
      this.usuariosParaRegistrar = [
        {
          nome: '',
          email: '',
          password: '',
          showPassword: false,
          grupoUsuario: null,
          funcoes: [],
        },
      ]
    },
    generateRandomPassword(length = 10) {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+-='
      let pass = ''
      for (let i = 0; i < length; i += 1) {
        pass += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      return pass
    },
    listarGrupoUsuariosBaseTemplate() {
      if (this.selectedTenantTemplate) {
        this.$isLoading(true)
        api.listarGrupoUsuariosEFuncoesBaseTemplate(this.selectedTenantTemplate.identifier)
          .then(response => {
            const { grupos, funcoes } = response.data || {}
            this.grupoUsuarios = Array.isArray(grupos) ? grupos : (response.data || [])
            this.funcoes = Array.isArray(funcoes) ? funcoes : []
          })
          .catch(() => {
            this.$erro('Erro ao carregar os grupos/funções do template')
          })
          .finally(() => {
            this.$isLoading(false)
          })
      }
    },
    togglePasswordVisibility(item) {
      if (!item) return
      const current = typeof item.showPassword === 'undefined' ? false : item.showPassword
      this.$set(item, 'showPassword', !current)
    },
    cancelar() {
      this.$router.push({ name: 'implantacoes' })
    },
  },
}

</script>
